import React from 'react';
import { NotificationItem as NotificationItemType } from '../notificationsTypes';
import { NotificationList } from './NotificationList';
import styles from './NotificationCard.module.css';

interface NotificationCardProps {
  notifications: NotificationItemType[];
  unreadCount: number;
  onMarkAsRead?: (id: string) => void;
  onViewAll?: () => void;
  maxItems?: number;
}

export const NotificationCard: React.FC<NotificationCardProps> = ({
  notifications,
  unreadCount,
  onMarkAsRead,
  onViewAll,
  maxItems = 5,
}) => {
  const displayedNotifications = notifications.slice(0, maxItems);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>Notifications</h3>
        {unreadCount > 0 && (
          <span className={styles.unreadBadge}>{unreadCount} unread</span>
        )}
      </div>
      <div className={styles.body}>
        <NotificationList
          notifications={displayedNotifications}
          onMarkAsRead={onMarkAsRead}
        />
      </div>
      {onViewAll && (
        <div className={styles.footer}>
          <button className={styles.viewAllBtn} onClick={onViewAll}>
            View All Notifications
          </button>
        </div>
      )}
    </div>
  );
};
